import { useTranslate } from "@refinedev/core";
import { Button, Modal } from "@fawkes/ui";

import type { SettingsTileComingSoonProps } from "./tiles/types";

// jve-settings: the interim "coming soon" dialog a tile shows until its real detail screen lands.
// Each configuration-group tile renders this while its api/ surface is being built; the per-tile
// migration session replaces it with the tile's own detail component (strangler-fig).
export function SettingsTileComingSoon({
  open,
  onClose,
  titleKey,
  itemKeys,
  context,
}: SettingsTileComingSoonProps) {
  const t = useTranslate();
  return (
    <Modal
      open={open}
      title={t(titleKey)}
      onClose={onClose}
      footer={
        <Button variant="secondary" onClick={onClose}>
          {t("common.back")}
        </Button>
      }
    >
      <div className="settings-tile-modal">
        <p className="settings-tile-modal-breadcrumb">
          {`${t("instellingen.title")} › ${context.label} › ${t(titleKey)}`}
        </p>
        <div className="settings-info-banner">{t("instellingen.comingSoon.body")}</div>
        <p className="settings-tile-modal-items-label">{t("instellingen.comingSoon.items")}</p>
        <ul className="settings-tile-modal-items">
          {itemKeys.map((key) => (
            <li key={key}>{t(key)}</li>
          ))}
        </ul>
      </div>
    </Modal>
  );
}
